import httpCommon, { httpFormData } from "./http-common";

// Sign up
const signUp = (data: any, onUploadProgress: (progressEvent: ProgressEvent) => void) => {
  return httpFormData.post("/v1/auth/signup", data, { onUploadProgress: (progressEvent: any) => onUploadProgress(progressEvent) });
};

// Sign in
const login = (data: any) => {
  return httpCommon.post("/v1/auth/login", data);
};

// Logout
const logout = (data: any) => {
  return httpCommon.post("/v1/auth/logout", data);
};

const refreshToken = (data: any) => {
  return httpCommon.post("/v1/auth/refresh", data);
};

// Implement email verification by code
const verifyEmailByCode = (data: any) => {
  return httpCommon.post("/v1/auth/verifications/email-by-code", data);
};

// Implement email verification by link
const verifyEmailByLink = (data: any) => {
  return httpCommon.post("/v1/auth/verifications/email-by-link", data);
};

const verifyUsernameByCode = (data: any) => {
  return httpCommon.post("/v1/auth/verifications/username-by-code", data);
};

const AuthService = {
  signUp,
  login,
  logout,
  refreshToken,
  verifyEmailByCode,
  verifyEmailByLink,
  verifyUsernameByCode,
};

export default AuthService;
